import type {
  ErpMaterialMappingResolution,
  ErpSystem,
  MaterialSearchResponse
} from "./adminApi";

export type CatalogMappingRow = MaterialSearchResponse["items"][number];

export const mergeCatalogMappingResolution = (
  catalogRows: CatalogMappingRow[],
  resolution: ErpMaterialMappingResolution
) => {
  const mappingsById = new Map(
    resolution.materials.map(material => [
      material.spyglassMaterialId,
      material
    ])
  );
  return catalogRows.map(row => {
    const mapping = mappingsById.get(row.spyglassMaterialId);
    return mapping
      ? {
          ...row,
          erpMappingStatus: mapping.erpMappingStatus,
          erpMaterials: mapping.erpMaterials
        }
      : row;
  });
};

export const mappingPageCoverage = (rows: CatalogMappingRow[]) =>
  rows.reduce(
    (coverage, row) => {
      if (row.erpMappingStatus === "confirmed") coverage.mapped += 1;
      if (row.erpMappingStatus === "unresolved") coverage.unresolved += 1;
      if (row.erpMappingStatus === "unavailable") coverage.unavailable += 1;
      return coverage;
    },
    { mapped: 0, unresolved: 0, unavailable: 0 }
  );

export const mappingSourceCoverage = (rows: CatalogMappingRow[]) =>
  rows.reduce(
    (coverage, row) => {
      const sources = new Set(
        row.erpMaterials.map(mapping => mapping.erpSystem)
      );
      if (sources.size) coverage.either += 1;
      if (sources.has("ecc")) coverage.ecc += 1;
      if (sources.has("s4")) coverage.s4 += 1;
      return coverage;
    },
    { either: 0, ecc: 0, s4: 0 }
  );

export const filterCatalogMappingsByErpSystem = (
  rows: CatalogMappingRow[],
  erpSystem?: ErpSystem
) => {
  if (!erpSystem) return rows;
  return rows.map(row => {
    const erpMaterials = row.erpMaterials.filter(
      mapping => mapping.erpSystem === erpSystem
    );
    return {
      ...row,
      erpMaterials,
      erpMappingStatus:
        row.erpMappingStatus === "unavailable"
          ? row.erpMappingStatus
          : erpMaterials.length
            ? ("confirmed" as const)
            : ("unresolved" as const)
    };
  });
};

export const catalogSearchFilters = (
  summitOnly: boolean,
  manufacturerFilterAvailable: boolean
) => (summitOnly && manufacturerFilterAvailable ? { summitOnly: true } : {});
